const CHANGED_EVENT = 'couplespace:llm-private-changed';

let cachedIds = new Set<string>();

export function isLlmPrivateBlock(blockId: string): boolean {
  return cachedIds.has(blockId);
}

export function setLlmPrivateMembership(blockId: string, isPrivate: boolean): void {
  const has = cachedIds.has(blockId);
  if (isPrivate === has) {
    return;
  }
  const next = new Set(cachedIds);
  if (isPrivate) {
    next.add(blockId);
  } else {
    next.delete(blockId);
  }
  cachedIds = next;
  notifyLlmPrivateChanged();
}

export function setLlmPrivateIds(ids: Iterable<string>): void {
  cachedIds = new Set(ids);
  notifyLlmPrivateChanged();
}

export function notifyLlmPrivateChanged(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new Event(CHANGED_EVENT));
}

export function subscribeLlmPrivate(listener: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }
  window.addEventListener(CHANGED_EVENT, listener);
  return () => window.removeEventListener(CHANGED_EVENT, listener);
}
